import { useState } from 'react';
import EditWarningModal from 'documents-ui/components/summary/EditWarningModal';
import { jsx as _jsx } from "react/jsx-runtime";
export default function useEditWarningModal({
  documentId,
  type,
  showEditWarnings,
  onConfirm,
  owner,
  showIcon
}) {
  const [showEditWarningModal, setShowEditWarningModal] = useState(false);
  function onChangeWithEditWarnings() {
    return showEditWarnings ? setShowEditWarningModal(showEditWarnings) : onConfirm();
  }
  function handleConfirm() {
    setShowEditWarningModal(false);
    onConfirm();
  }
  function handleReject() {
    setShowEditWarningModal(false);
  }
  let editWarningModal = null;
  if (showEditWarningModal) {
    editWarningModal = /*#__PURE__*/_jsx(EditWarningModal, {
      documentId: documentId,
      "data-test-id": "edit-warning-modal",
      type: type,
      owner: owner,
      handleConfirm: handleConfirm,
      handleReject: handleReject,
      showIcon: showIcon
    });
  }
  return {
    editWarningModal,
    onChangeWithEditWarnings
  };
}